import { jsx } from 'panel';
import { SharingStatusButtonEl } from 'common/widgets/sharing/status-button';
export function template() {
  return jsx(SharingStatusButtonEl, {
    attrs: {
      elref: "sharingButton",
      disabled: this.helpers.isDisabled(),
      id: this.attr("id"),
      'project-id': this.attr("project-id"),
      theme: this.attr("theme"),
      type: this.attr("type")
    },
    on: {
      click: this.helpers.isDisabled() ? null : this.helpers.handleClick
    }
  });
}